import { useCallback, useEffect, useState } from 'react'

import { isMobile } from 'utils/isMobile'

type Props = {
  minKeyboardHeight?: number
  defaultValue?: boolean
}

export const useDetectKeyboardOpen = ({
  minKeyboardHeight = 300,
  defaultValue = false,
}: Props = {}) => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(defaultValue)

  const listener = useCallback(() => {
    if (!isMobile()) return

    if (
      typeof window.visualViewport === 'undefined'
      || window.visualViewport === null
    ) {
      return
    }
    const newState
      = window.screen.height - minKeyboardHeight > window.visualViewport.height
    if (isKeyboardOpen !== newState) {
      setIsKeyboardOpen(newState)
    }
  }, [isKeyboardOpen, minKeyboardHeight])

  useEffect(() => {
    if (
      typeof window.visualViewport !== 'undefined'
      && window.visualViewport !== null
    ) {
      window.visualViewport.addEventListener('resize', listener)
    }
    return () => {
      if (
        typeof window.visualViewport !== 'undefined'
        && window.visualViewport !== null
      ) {
        window.visualViewport.removeEventListener('resize', listener)
      }
    }
  }, [listener])

  return { isKeyboardOpen }
}
